/* eslint-disable no-unused-vars */
import React, { Fragment, useEffect, useState } from "react";
import Chart from "react-apexcharts";
import Breadcrumb from "../../../common/breadcrumb/breadcrumb";
import { apexcharts1, apexcharts2, apexcharts3, apexcharts4, apexcharts5, apexcharts6, apexchartsradial } from "../charts/apexchartsData";
import { chartist1data, chartist2data } from "../charts/chartistchartsData";
import Apexchart from "react-apexcharts";
import Calendar from "react-calendar";
import { MoreHorizontal } from "react-feather";
import { Button, Card, CardBody, CardHeader, Col, Container, Media, Modal, ModalBody, ModalHeader, Row, Table } from "reactstrap";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const AdminDefault = (props) => {
    const [chart1, setcharts1] = useState(apexcharts1);
      const [date, setDate] = useState(new Date());
    
      const [modal, setModal] = useState(false);
      const toggle = () => {
        setModal(!modal);
        localStorage.setItem("isUser", null);
      };
      const onChange = (date) => setDate(date);
    
      useEffect(() => {
        if (localStorage.getItem("isUser") === "true") {
          setModal(true);
        } else {
          setModal(false);
        }
      }, []);

    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const userType = localStorage.getItem("userType");
    const valetId = localStorage.getItem("valetId");

    useEffect(() => {
        if (userType === "valet") {
            const checkNotifications = async () => {
                try {
                    const response = await axios.get(
                        `${process.env.REACT_APP_PUBLIC_SERVER}/api/notifications/valet/${valetId}`,
                        {
                            headers: { Authorization: `Bearer ${token}` },
                        }
                    );
                    const notifications = response.data;
                    if (notifications.length > 0) {
                        Swal.fire({
                            title: "Tienes notificaciones nuevas",
                            text: `Hay ${notifications.length} notificaciones pendientes.`,
                            icon: "info",
                            confirmButtonText: "OK",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate("/pages/notifications");
                            }
                        });
                    }
                } catch (error) {
                    console.error("Error al verificar notificaciones:", error);
                }
            };
            checkNotifications();
        }
    }, [userType, valetId, token, navigate]);

    return(
    <Fragment>
      <Breadcrumb parent="Dashboard" title="Default" />
      <Container fluid={true}>
        <Row>
          <Col lg="12 xl-100">
            <Row>
              <Col xl="3 xl-50" md="6 box-col-6">
                <Card className="gradient-primary o-hidden">
                  <CardBody className="tag-card">
                    <div className="default-chart">
                      <div className="apex-widgets">
                        <Chart id="area-widget-chart" options={chart1.options} series={chart1.series} height="120" type="line" />
                      </div>
                      <div className="widgets-bottom">
                        <h5 className="f-w-700 mb-0">
                          Total Sale
                          <span className="pull-right">75 / 100 </span>
                        </h5>
                      </div>
                    </div>
                    <span className="tag-hover-effect">
                      <span className="dots-group">
                        <span className="dots dots1"></span>
                        <span className="dots dots2 dot-small"></span>
                        <span className="dots dots3 dot-small"></span>
                        <span className="dots dots4 dot-medium"></span>
                        <span className="dots dots5 dot-small"></span>
                        <span className="dots dots6 dot-small"></span>
                        <span className="dots dots7 dot-small-semi"></span>
                        <span className="dots dots8 dot-small-semi"></span>
                        <span className="dots dots9 dot-small"></span>
                      </span>
                    </span>
                  </CardBody>
                </Card>
              </Col>
              <Col xl="3 xl-50" md="6 box-col-6">
                <Card className="gradient-secondary o-hidden">
                  <CardBody className="tag-card">
                    <div className="default-chart">
                      <div className="apex-widgets">
                        <Chart id="area-widget-chart-2" options={apexcharts2.options} series={apexcharts2.series} height="130" type="line" />
                      </div>
                      <div className="widgets-bottom">
                        <h5 className="f-w-700 mb-0">
                          Total Visits
                          <span className="pull-right">70 / 100 </span>
                        </h5>
                      </div>
                    </div>
                    <span className="tag-hover-effect">
                      <span className="dots-group">
                        <span className="dots dots1"></span>
                        <span className="dots dots2 dot-small"></span>
                        <span className="dots dots3 dot-small"></span>
                        <span className="dots dots4 dot-medium"></span>
                        <span className="dots dots5 dot-small"></span>
                        <span className="dots dots6 dot-small"></span>
                        <span className="dots dots7 dot-small-semi"></span>
                        <span className="dots dots8 dot-small-semi"></span>
                        <span className="dots dots9 dot-small"></span>
                      </span>
                    </span>
                  </CardBody>
                </Card>
              </Col>
              <Col xl="3 xl-50" md="6 box-col-6">
                <Card className="gradient-warning o-hidden">
                  <CardBody className="tag-card">
                    <div className="default-chart">
                      <div className="apex-widgets">
                        <Chart id="area-widget-chart-3" options={apexcharts3.options} series={apexcharts3.series} height="130" type="line" />
                      </div>
                      <div className="widgets-bottom">
                        <h5 className="f-w-700 mb-0">
                          Total Stock
                          <span className="pull-right">70 / 100 </span>
                        </h5>
                      </div>
                    </div>
                    <span className="tag-hover-effect">
                      <span className="dots-group">
                        <span className="dots dots1"></span>
                        <span className="dots dots2 dot-small"></span>
                        <span className="dots dots3 dot-small"></span>
                        <span className="dots dots4 dot-medium"></span>
                        <span className="dots dots5 dot-small"></span>
                        <span className="dots dots6 dot-small"></span>
                        <span className="dots dots7 dot-small-semi"></span>
                        <span className="dots dots8 dot-small-semi"></span>
                        <span className="dots dots9 dot-small"> </span>
                      </span>
                    </span>
                  </CardBody>
                </Card>
              </Col>
              <Col xl="3 xl-50" md="6 box-col-6">
                <Card className="gradient-info o-hidden">
                  <CardBody className="tag-card">
                    <div className="default-chart">
                      <div className="apex-widgets">
                        <Chart id="area-widget-chart-4" options={apexcharts4.options} series={apexcharts4.series} height="130" type="line" />
                      </div>
                      <div className="widgets-bottom">
                        <h5 className="f-w-700 mb-0">
                          Total Value
                          <span className="pull-right">70 / 100 </span>
                        </h5>
                      </div>
                    </div>
                    <span className="tag-hover-effect">
                      <span className="dots-group">
                        <span className="dots dots1"></span>
                        <span className="dots dots2 dot-small"></span>
                        <span className="dots dots3 dot-small"></span>
                        <span className="dots dots4 dot-medium"></span>
                        <span className="dots dots5 dot-small"></span>
                        <span className="dots dots6 dot-small"></span>
                        <span className="dots dots7 dot-small-semi"></span>
                        <span className="dots dots8 dot-small-semi"></span>
                        <span className="dots dots9 dot-small"> </span>
                      </span>
                    </span>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        
      </Container>
    </Fragment>);
};

export default AdminDefault;